// We need jQuery
var $ = window.jQuery;

export default {
  loaded() {
    console.log('heya')
    $('button.show').on('click', function() {
      let month = $(this).closest('.month-row').data('month')
      $('.month-detail[data-month="' + month + '"]').toggleClass('d-none')
    })
  }
};
